/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Přílohy`
};

const da_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Vedhæftede filer`
};

const de_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Anhänge`
};

const en_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Attachments`
};

const es_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Archivos adjuntos`
};

const fr_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Pièces jointes`
};

const hu_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Mellékletek`
};

const it_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Allegati`
};

const nl_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Bijlagen`
};

const pl_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Załączniki`
};

const pt_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Anexos`
};

const sv_contact_fields_attachments = /** @type {(inputs: {}) => string} */ () => {
	return `Bilagor`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_fields_attachments = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_fields_attachments(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_fields_attachments", locale)
	if (locale === "cs") return cs_contact_fields_attachments(inputs)
	if (locale === "da") return da_contact_fields_attachments(inputs)
	if (locale === "de") return de_contact_fields_attachments(inputs)
	if (locale === "en") return en_contact_fields_attachments(inputs)
	if (locale === "es") return es_contact_fields_attachments(inputs)
	if (locale === "fr") return fr_contact_fields_attachments(inputs)
	if (locale === "hu") return hu_contact_fields_attachments(inputs)
	if (locale === "it") return it_contact_fields_attachments(inputs)
	if (locale === "nl") return nl_contact_fields_attachments(inputs)
	if (locale === "pl") return pl_contact_fields_attachments(inputs)
	if (locale === "pt") return pt_contact_fields_attachments(inputs)
	return sv_contact_fields_attachments(inputs)
};
export { contact_fields_attachments as "contact.fields.attachments" }